// extracted by mini-css-extract-plugin
export var aboveInput = "_l2-0";
export var actionButton = "_l2-5";
export var actionButtonContainer = "_l2-1";
export var actionIcon = "_l2-6";
export var aiInfoContainer = "_l2-2";
export var attachmentWrapper = "_l2-7";
export var bold = "_l2-3";
export var checkIcon = "_l2-8";
export var clickingRecipientBar = "_l2-11";
export var commentThreadSwitch = "_l2-a";
export var draftImage = "_l2-b";
export var draftImageContainer = "_l2-c";
export var draftImages = "_l2-e";
export var editButton = "_l2-g";
export var editor = "_l2-f";
export var editorContainer = "_l2-y";
export var editorErrorTooltipWrapper = "_l2-9";
export var headerDivider = "_l2-h";
export var icon = "_l2-i";
export var info = "_l2-j";
export var internal = "_l2-n";
export var internalDivider = "_l2-k";
export var internalMessage = "_l2-l";
export var messageInputCard = "_l2-m";
export var messageInputForm = "_l2-o";
export var messageInputFormInternal = "_l2-p";
export var options = "_l2-q";
export var publicMessageCustomer = "_l2-s";
export var publicMessageMerchant = "_l2-r";
export var removeImageButton = "_l2-d";
export var replyButtons = "_l2-t";
export var showSignatureButton = "_l2-u";
export var spinner = "_l2-v";
export var verticalButtonDivider = "_l2-4";
export var visibilitySelector = "_l2-w";
export var warning = "_l2-x";
export var wrappingText = "_l2-z";
export var writingInternalNoteTopBorder = "_l2-10";